import React from 'react';

export const VeCoLogo = ({ className = "h-12 w-auto" }) => {
  return (
    <svg 
      viewBox="0 0 200 80" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background gradient (optional - can be removed for transparent) */}
      <defs>
        <linearGradient id="vecoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#14b8a6" />
          <stop offset="50%" stopColor="#7c3aed" />
          <stop offset="100%" stopColor="#10b981" />
        </linearGradient>
      </defs>
      
      {/* VeCo stylized text */}
      <g transform="translate(10, 20)">
        {/* V - chevron shape */}
        <path
          d="M 0,30 L 15,0 L 30,15 L 25,20 L 15,10 L 5,25 Z"
          fill="white"
          stroke="none"
        />
        
        {/* e - rounded lowercase */}
        <ellipse
          cx="50"
          cy="25"
          rx="12"
          ry="12"
          fill="white"
        />
        <path
          d="M 50,13 L 50,25 L 62,25"
          stroke="white"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* C - open curve */}
        <path
          d="M 90,15 Q 70,15 70,25 Q 70,35 90,35"
          stroke="white"
          strokeWidth="8"
          fill="none"
          strokeLinecap="round"
        />
        
        {/* o - circle */}
        <circle
          cx="110"
          cy="25"
          r="12"
          fill="white"
        />
        
        {/* Small smile/checkmark inside o */}
        <path
          d="M 105,25 L 108,28 L 115,21"
          stroke="#14b8a6"
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      
      {/* shop text */}
      <text
        x="50"
        y="65"
        fontFamily="sans-serif"
        fontSize="18"
        fontWeight="300"
        fill="white"
        letterSpacing="1"
      >
        shop
      </text>
    </svg>
  );
};

export default VeCoLogo;
